import React, { useCallback, useEffect, useRef, useState } from "react";

// Jds
import { Container, Notifications, SearchBox, Text } from "@jds/core";

// Mui
import { Box, ImageList } from "@mui/material";

// Local
import EventBanner from "../components/UI/EventBanner";
import EventDescriptionCard from "../components/UI/Cards/EventDescriptionCard";
import Face from "../components/UI/Face";
import { useParams } from "react-router-dom";
import useApiHttp from "../hooks/use-http";
import EmptyState from "../components/NoData/EmptyState";
import Loader from "../components/UI/Loader/Loader";
import GridContainer from "../components/Layout/GridContainer";
import PageLoader from "../components/UI/Loader/PageLoader";
import { imgValidationCheck, validateFileSignature } from "../util/helper";
import NameOfFaceForm from "../components/UI/Form/NameOfFaceForm";
import JdsModal from "../components/UI/JdsModal";
import FaceListModal from "../components/UI/FaceListModal";
import { FilterList } from "@mui/icons-material";
import ActiveAlertContainer from "../components/UI/ActiveAlertContainer/ActiveAlertContainer";

export default function Faces() {
  const { id: eventId } = useParams();
  const { sendRequest: searchByNameRequest, isLoading: issearchByNameLoading } =
    useApiHttp();
  const { sendRequest: getPhotoList, isLoading: isGetPhotoListLoading } =
    useApiHttp();
  const { sendRequest: searchImgRequest, isLoading: searchImgLoading } =
    useApiHttp();
  const { sendRequest: resquestIdSearch, isLoading: resquestIdSearchLoading } =
    useApiHttp();
  const [planActive, setPlanActive] = useState(true);
  const [planActiveMsg, setPlanActiveMsg] = useState("");
  const [isPoolLoading, setIsPoolLoading] = useState(false);
  const [facesList, setFacesList] = useState([]);
  const [requestId, setRequestId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [clearPoolRequestInterval, setClearPoolRequestInterval] =
    useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [totalFacesCount, setTotalFacesCount] = useState(0);
  const searchImgInput = useRef(null);
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [faceName, setFaceName] = useState("");
  const [faceData, setFaceData] = useState({});
  const [modalUsername, setModalUsername] = useState();
  const [faceCount, setFaceCount] = useState(0);
  const [isFaceLisModalClosed, setIsFaceModalClose] = useState(true);
  const getFaceImages = (page) => {
    getPhotoList(
      {
        url: `face/clusters?eventId=${eventId}&size=200&page=${page}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        if (page === 0) {
          setFacesList(data?.data);
          setTotalFacesCount(data?.count);
          setLastPage(data?.lastPage);
        } else {
          if (data?.data) {
            setFacesList((pre) => [...pre, ...data?.data]);
            setTotalFacesCount(data?.count);
            setLastPage(data?.lastPage);
          }
        }
      },
      (err, data) => {
        if (data?.statusCode == 402) {
          setPlanActive(false);
          setPlanActiveMsg(data?.message);
        } else {
          Notifications.toast.error({
            id: "face-page",
            title: data?.message,
          });
        }
      }
    );
  };

  const searchFaceByName = (name) => {
    searchByNameRequest(
      {
        url: `face/search/name?name=${name}&eventId=${eventId}&size=50&page=${page}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        Notifications.toast.success({ id: "search_face", title: data.message });
        if (page === 0) {
          setFacesList(data?.data);
          setTotalFacesCount(data?.count);
          setLastPage(data?.lastPage);
        } else {
          if (data?.data) {
            setFacesList((pre) => [...pre, ...data?.data]);
            setTotalFacesCount(data?.count);
            setLastPage(data?.lastPage);
          }
        }
      },
      (err, data) => {
        Notifications.toast.error({ id: "search_face", title: data.message });
        setFacesList([]);
        setTotalFacesCount(0);
      }
    );
  };

  const searchFaceByImage = (file) => {
    const formData = new FormData();
    formData.append("uploadFile", file);
    formData.append("eventId", eventId);
    searchImgRequest(
      {
        url: `face/search-image`,
        method: "POST",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        setRequestId(data?.data?.requestId);
        setIsPoolLoading(true);
      },
      (err, data) => {
        Notifications.toast.error({ id: "search_face", title: data.message });
      }
    );
  };

  const searchByRequestId = (id) => {
    resquestIdSearch(
      {
        url: `face/pool-search-result?requestId=${id}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        if (data?.data) {
          setClearPoolRequestInterval(true);
          setIsPoolLoading(false);
          setFacesList(data.data);
          setLastPage(data?.lastPage);
        }
        // setFacesList(data.data);
      }
    );
  };

  useEffect(() => {
    if (searchValue.length) {
      searchFaceByName(searchValue);
    }
    if (searchValue.length < 1) {
      getFaceImages(page);
    }
  }, [page]);

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (issearchByNameLoading || isGetPhotoListLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [issearchByNameLoading, isGetPhotoListLoading, lastPage]
  );

  // useEffect(() => {
  //   let poolRequestInterval;
  //   if (requestId) {
  //     poolRequestInterval = setInterval(() => {
  //       searchByRequestId(requestId);
  //     }, 5000);
  //     // if (clearPoolRequestInterval) {
  //
  //     //   return clearInterval(poolRequestInterval);
  //     // }
  //   }
  //   return () => {
  //     if (poolRequestInterval) {
  //       clearInterval(poolRequestInterval);
  //     }
  //   };
  // }, [requestId, clearPoolRequestInterval]);

  // useEffect(() => {
  //   let poolRequestInterval;
  //   if (requestId) {
  //     poolRequestInterval = setInterval(() => {
  //       searchByRequestId(requestId);
  //     }, 5000);
  //   }
  //   return () => {
  //     if (poolRequestInterval && clearPoolRequestInterval) {
  //       clearInterval(poolRequestInterval);
  //       setClearPoolRequestInterval(false);
  //     }
  //   };
  // }, [requestId, clearPoolRequestInterval]);

  useEffect(() => {
    if (requestId) {
      const id = setInterval(() => {
        searchByRequestId(requestId);
      }, 5000);
      setIntervalId(id);

      // Clear the interval on component unmount
      return () => clearInterval(id);
    }
  }, [requestId]);

  useEffect(() => {
    if (clearPoolRequestInterval && intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
      setClearPoolRequestInterval(false);
    }
  }, [clearPoolRequestInterval, intervalId]);

  if (!planActive) {
    return <ActiveAlertContainer message={planActiveMsg} />;
  }
  return (
    <>
      <Container
        fullWidth
        horizontalAlign="space-between"
        style={{
          marginBottom: "40px",
          paddingTop: "32px",
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          paddingBottom: "16px",
          zIndex: 30,
        }}
      >
        <Container direction="row" verticalAlign="end" gap={8}>
          <Text text={`Faces `} appearance="heading-xs" />
          <Text
            text={`${totalFacesCount ? `- ${totalFacesCount}` : ""}`}
            appearance="body-m"
            color="primary-grey-80"
          />
        </Container>
        <Container
          direction="row"
          horizontalAlign="right"
          verticalAlign="center"
          gap={8}
        >
          <input
            ref={searchImgInput}
            type="file"
            accept=".png, .jpg, .jpeg"
            onChange={(e) => {
              const file = e.target.files[0];
              if (imgValidationCheck(e)) {
                validateFileSignature(file, {
                  jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
                  png: ["89504e47"],
                })
                  .then((isValid) => {
                    if (isValid) {
                      searchFaceByImage(e.target.files[0]);
                    } else {
                      Notifications.toast.error({
                        id: "search-face-img",
                        title:
                          "Please upload a valid image file (JPG, JPEG and PNG).",
                      });
                    }
                  })
                  .catch((error) => {
                    Notifications.toast.error({
                      id: "search-face-img",
                      title:
                        "Please upload a valid image file (JPG, JPEG and PNG).",
                    });
                  });
              } else {
                Notifications.toast.error({
                  id: "search-face-img",
                  title:
                    "Please upload a valid image file (JPG, JPEG and PNG).",
                });
              }
            }}
          />
          <SearchBox
            label="Search Faces"
            prefix="IcSearch"
            value={searchValue}
            suffix={
              !requestId && searchValue.length === 0 ? "IcPhoto" : "IcError"
            }
            onSuffixClick={() => {
              if (requestId || searchValue.length !== 0) {
                if (page !== 0) {
                  setPage(0);
                } else {
                  getFaceImages(0);
                }
                setSearchValue("");
                setRequestId("");
              } else {
                if (searchValue.length === 0) {
                  if (searchImgInput.current) {
                    searchImgInput.current.value = null; //reset file
                    searchImgInput.current.click();
                  }
                }
              }
            }}
            onChange={(e) => {
              const searchValue = e.target.value;
              setSearchValue(searchValue);
              if (searchValue.length) {
                if (page !== 0) {
                  setPage(0);
                } else {
                  searchFaceByName(searchValue);
                }
              }
              if (searchValue.length < 1) {
                if (page !== 0) {
                  setPage(0);
                } else {
                  getFaceImages(0);
                }
              }
            }}
          />
        </Container>
      </Container>
      <Container fullWidth>
        {facesList?.length ? (
          <Container fullWidth direction="column">
            {/* <GridContainer minWidth="184px" maxWidth="184px"> */}
            <ImageList
              cols={5}
              rowHeight={240}
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {facesList.map((item, i) => {
                return (
                  <div ref={facesList.length === i + 1 ? lastElementRef : null}>
                    <Face
                      key={i}
                      data={item}
                      isSuccess={() => {
                        // window.scrollTo(0, 0);
                        // if (page !== 0) {
                        //   setPage(0);
                        // } else {
                        //   if (searchValue) {
                        //     searchFaceByName(searchValue);
                        //   } else {
                        //     getFaceImages(0);
                        //   }
                        // }
                      }}
                      setFaceData={(val) => {
                        setFaceData(val);
                      }}
                      setEditModalClose={(val) => {
                        setEditModalClose(val);
                      }}
                      isFaceLisModalClosed={isFaceLisModalClosed}
                      setIsFaceModalClose={setIsFaceModalClose}
                    />
                  </div>
                );
              })}
            </ImageList>
            {/* </GridContainer> */}
            {((issearchByNameLoading && page !== 0) ||
              (isGetPhotoListLoading && page !== 0)) && <Loader size="small" />}
          </Container>
        ) : (
          <EmptyState title="No Faces" subtitle="" action={false} />
        )}
      </Container>
      {((issearchByNameLoading && page == 0) ||
        searchImgLoading ||
        resquestIdSearchLoading ||
        isPoolLoading ||
        (isGetPhotoListLoading && page == 0)) && (
        <PageLoader
          open={
            issearchByNameLoading ||
            searchImgLoading ||
            resquestIdSearchLoading ||
            isPoolLoading ||
            isGetPhotoListLoading
          }
          label={isPoolLoading && "Please wait for a while..."}
          labelprops={{ color: "white" }}
        />
      )}
      {/* NameOfFace form Modal */}
      <JdsModal
        header="Name of the Face"
        size="m"
        close={isEditModalClose}
        onClose={() => {
          setEditModalClose(true);
        }}
      >
        {!isEditModalClose && (
          <NameOfFaceForm
            data={faceData}
            isSuccess={(bool, name, id) => {
              setFaceName(name);
              setFacesList((pre) => {
                const updateList = pre.map((item) => {
                  if (item.clusterId == id) {
                    return { ...item, username: name };
                  } else {
                    return item;
                  }
                });
                return updateList;
              });
            }}
          />
        )}
      </JdsModal>

      <JdsModal
        header={`${modalUsername || "Unnamed"} - ${faceCount}`}
        kind="custom"
        close={isFaceLisModalClosed}
        onClose={() => {
          setIsFaceModalClose(true);
          // window.location.reload();
        }}
      >
        {!isFaceLisModalClosed && (
          <FaceListModal
            modalUsername={modalUsername}
            faceCount={faceCount}
            setModalUsername={setModalUsername}
            setFaceCount={setFaceCount}
            isFaceLisModalClosed={isFaceLisModalClosed}
            setIsFaceModalClose={setIsFaceModalClose}
            data={faceData}
            setEditModalClose={(id, name, url) => {
              setEditModalClose(false);
              const updateData = facesList.find(
                (item, val) => item.clusterId == id
              );
              if (updateData) {
                setFaceData(updateData);
              } else {
                setFaceData({
                  clusterId: id,
                  username: name,
                  mediaUrl: url || "",
                });
              }
            }}
          />
        )}
      </JdsModal>
    </>
  );
}
